import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import some from 'lodash/some';
import Money from '../../components/Money';
import PaymentModalCustomTip from '../containers/PaymentModalCustomTip';
import { tipShape } from '../../shapes';

const Tip = ({ tips, onTipSelect, off, toggle, toggled, hasCustomTip, customTip, total }) => (
  <div>
    <div className="c-payment-modal-heading u-mt- u-mb u-hide-for-medium-and-up">Tip</div>
    <div
      style={{ height: '40px' }}
      className="u-flex u-align-center u-justify-content-space-between u-mb- u-flex-wrap u-hide-for-small-and-down"
    >
      <div className="c-payment-modal-heading u-mt-">Tip</div>
      <div className="u-flex u-justify-content-end">
        {toggled && <PaymentModalCustomTip close={off} />}
      </div>
    </div>
    <div className="u-text-center u-mb- c-payment-modal-tip">
      {tips.map((tip, i) => {
        if (!tip.amount && !some(tips, 'amount')) return null;
        return (
          <button
            className={classnames('c-payment-modal-tip-button', { 'is-selected': tip.active && !toggled })}
            type="radio"
            name="radio-reserve"
            id={`payment_tip${i}`}
            onClick={() => onTipSelect(tip.flat ? tip.amount : tip.value)}
            key={tip.value || tip.amount}
          >
            <div className="c-payment-modal-tip-button__heading">
              {(tip.value || tip.flat) ? <Money>{tip.amount}</Money> : 'None'}
            </div>
            <div className="c-payment-modal-tip-button__subheading">
              {tip.desc}
            </div>
          </button>
        );
      })}
      <button
        type="button"
        className={classnames(
          'c-payment-modal-tip-button', { 'is-selected': hasCustomTip || toggled }
        )}
        onClick={toggle}
      >
        {
          hasCustomTip ? (
            <div>
              <div className="c-payment-modal-tip-button__heading">
                <Money>{customTip}</Money>
              </div>
              <div className="c-payment-modal-tip-button__subheading">
                About {Math.floor((customTip / total) * 100)}%
              </div>
            </div>
          ) : (
            <div className="c-payment-modal-tip-button__heading">
              {some(tips, 'amount') ? 'Custom' : 'Add Tip'}
            </div>
          )
        }
      </button>
    </div>
    <div className="u-flex u-justify-content-end u-mt- u-hide-for-medium-and-up">
      {toggled && <PaymentModalCustomTip close={off} />}
    </div>
  </div>
);
Tip.propTypes = {
  tips: PropTypes.arrayOf(tipShape),
  onTipSelect: PropTypes.func,
  toggle: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  hasCustomTip: PropTypes.bool.isRequired,
  customTip: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};
Tip.defaultProps = {
  tips: [],
  onTipSelect: null,
};

export default Tip;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PaymentModalTip.jsx